angular.module('app').directive('apSelectImage',
    [
        function () {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: '/app/views/directives/apSelectImage.html',
                scope: {
                    // Use '@' for one way binding.  String value is returned.
                    // Use '=' for two way binding.  An object is returned.
                    // Use '&' for a method.
                    maxSizeKb: '=maxSizeKb',
                    selectedFileName: '=selectedFileName',
                    selectedMimeType: '=selectedMimeType',
                    selectedFileContents: '=selectedFileContents'
                },

                controller: function($scope) {

                    $scope.selectImageModel = {
                        //maxSizeKb: $scope.maxSizeKb,
                        //fileType : '', //'.bmp,.jpeg,.gif',
                        selectedFileName: $scope.selectedFileName,
                        selectedFileContents: $scope.selectedFileContents,
                        selectedMimeType: $scope.selectedMimeType,
                        validationMessage : ''
                    };

                    $scope.clearSelectedFile = function clearSelectedFile() {
                        $scope.selectImageModel.selectedFileName = '';
                        $scope.selectImageModel.selectedFileContents = '';
                        $scope.selectImageModel.selectedMimeType = '';
                        $scope.selectImageModel.validationMessage = '';
                    };
                }
            };
        }
    ]
);